let state = {
    loading:false,
    common:{
        origin:"webapp",
        socialplaceprime_id:""
    },
    hideCard:false,
    util:null,
    menu:null,
    drawer: false,
    loginDialog: false,
    registerDialog: false,
    addressDialog: false,
    setAddressDialog: false,
    updateUserDialog: false,
    resetPasswordDialog: false,
    smsPasswordDialog: false,
    typeDialog:false,
    productDialog: false,
    subtypes: false,
    typeSelected: null,
    subtypes:[],
    products: {
        recordsTotal:0,
        page:1,
        limit:30,
        order_column:'',
        order_dir:'',
        recordsFiltered:0,
        data:[]
    },
    pizza:{
        recheios:[],
        tamanhos:[],
        bordas:[],
        massas:[],
        config:{}
    },
    sizes:[],
    product:null,
    multiProducts:[],
    type:null,
    user: null,
    restaurant: null,
    restaurant_id:localStorage.getItem('restaurant_id') || null,
    myOrders: [],
    myOrder:null,
    token: localStorage.getItem('token') || null,
    phone_validation:null,
    authError: null,
    connectionError: false,
    cart:JSON.parse(localStorage.getItem('cart')) || null,
    coupon:localStorage.getItem('coupon') || null,
    cartProducts:JSON.parse(localStorage.getItem('cartProducts')) || [],
    agendamento:JSON.parse(localStorage.getItem('agendamento')) || false,
    pendingOrder:null,
    waitTime:0,
    pendingOrderId: localStorage.getItem('pendingOrderId') || null, 
    subtype:'',
    filter:{
        photo:'',
        active:'',
        stock:'',
        pending:'',
        highlight:''
    },
    search:'',
    tags:[],
    states:[],
    cities:[],
    payments:null,
    isCleanPage:false,
}

export default state